import {Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'exg-chips',
  templateUrl: './exg-chips.component.html'
})
export class ExgChipsComponent {

  @Input() caption!: string;
  @Input() disabled!: string;
  @Input() list: Array<any> = [];
  @Input() listdisplay!: string;
  @Input() containerclass = 'spawn';

  @Output() ItemClose: EventEmitter<{item: any, index: number}> = new EventEmitter<{item: any, index: number}>();
  @Output() ItemClick: EventEmitter<{item: any, index: number}> = new EventEmitter<{item: any, index: number}>();

  constructor() { }

  public displayItem(item: any): any {
    if (this.listdisplay) {
      return item[this.listdisplay];
    }
    return '-';
  }
  closeChip(item: any, index: number, e: MouseEvent ): void {
    e.preventDefault();
    this.ItemClose.emit({index, item});
  }
  clickChip(item: any, index: number): void {
    this.ItemClick.emit({index, item});
  }
}
